import React from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { tokens } from '../../theme';

export const cardSx = {
  bgcolor: tokens.surfaceLowest,
  border: `1px solid ${tokens.outlineVariant}`,
  borderRadius: 3,
  boxShadow: '0 1px 2px rgba(19, 27, 46, 0.04)',
} as const;

// Stitch section: small caps label, headline, optional lead, then content.
export default function Section({
  id,
  label,
  title,
  lead,
  children,
  card = false,
  tone = 'surface',
  sx,
}: {
  id: string;
  label?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  children?: React.ReactNode;
  card?: boolean;
  tone?: 'surface' | 'low';
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      component='section'
      aria-labelledby={id}
      sx={[
        { mt: { xs: 5, md: 8 }, scrollMarginTop: '96px' },
        card ? { ...cardSx, p: { xs: 3, md: 5 } } : {},
        tone === 'low' && !card
          ? { bgcolor: tokens.surfaceLow, borderRadius: 3, p: { xs: 3, md: 5 } }
          : {},
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {label && (
        <Typography
          variant='labelCaps'
          component='p'
          sx={{ color: tokens.accentText }}
        >
          {label}
        </Typography>
      )}
      <Typography
        id={id}
        component='h2'
        variant='h2'
        sx={{ mt: label ? 1 : 0 }}
      >
        {title}
      </Typography>
      {lead && (
        <Typography
          variant='body2'
          component='div'
          sx={{ mt: 2, maxWidth: '46rem', '& p': { m: 0 }, '& p + p': { mt: 1.5 } }}
        >
          {lead}
        </Typography>
      )}
      {children}
    </Box>
  );
}
